import { FileText } from 'lucide-react';
import { DocPage } from '@/components/investor';
import { onePagerSections, onePagerStatus, onePagerSummary, onePagerTop } from '@/content/onePager';

/**
 * Direct-access investor page — deliberately absent from the navigation.
 * Content lives in src/content/onePager.tsx, mirroring docs/investors/one-pager.md.
 */
export function OnePagerPage() {
  return (
    <DocPage
      badgeIcon={FileText}
      badge="Investor One-Pager"
      title="DialogMe — customer communication, automated all the way to the transaction."
      status={onePagerStatus}
      summary={onePagerSummary}
      top={onePagerTop}
      sections={onePagerSections}
      contactEmail="investors@dialogme.ai"
      deckPath="/pitch"
      footer="Confidential. Zero paying customers as of this page; every commercial figure is a management scenario."
    />
  );
}
